import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const DeleteConfirmationModal = ({
    show,
    onConfirm,
    onCancel,
    itemName,
    title = 'Confirmer la suppression',
    confirmLabel = 'Supprimer',
    confirmStyle = 'danger',
    icon = 'trash',
    message = null,
    isIrreversible = true
}) => {
    const iconClass = `fa fa-${icon}`;
    const warningColor = confirmStyle === 'danger' ? '#d9534f' : confirmStyle === 'success' ? '#5cb85c' : '#5bc0de';

    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header
                closeButton
                style={{
                    background: confirmStyle === 'danger'
                        ? 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)'
                        : confirmStyle === 'success'
                        ? 'linear-gradient(135deg, #4caf50 0%, #388e3c 100%)'
                        : 'linear-gradient(135deg, #2196F3 0%, #03A9F4 100%)',
                    color: 'white',
                    borderBottom: 'none'
                }}
            >
                <Modal.Title style={{ fontWeight: '600', fontSize: '20px' }}>
                    <i className={iconClass} style={{ marginRight: '12px' }} />
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '30px', textAlign: 'center' }}>
                <div style={{ marginBottom: '20px' }}>
                    <i
                        className={iconClass}
                        style={{
                            fontSize: '48px',
                            color: warningColor,
                            marginBottom: '15px'
                        }}
                    />
                </div>
                {message ? (
                    <p style={{ fontSize: '16px', color: '#495057', marginBottom: '15px' }}>
                        {message}
                    </p>
                ) : (
                    <p style={{ fontSize: '16px', color: '#495057', marginBottom: '15px' }}>
                        Êtes-vous sûr de vouloir {itemName} ?
                    </p>
                )}
                {isIrreversible && (
                    <p style={{
                        color: warningColor,
                        fontSize: '14px',
                        fontWeight: '500',
                        marginTop: '15px'
                    }}>
                        <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }} />
                        Cette action est irréversible.
                    </p>
                )}
            </Modal.Body>
            <Modal.Footer style={{
                justifyContent: 'center',
                gap: '15px',
                padding: '20px 30px',
                borderTop: '1px solid #e9ecef'
            }}>
                <Button
                    onClick={onCancel}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 25px',
                        fontWeight: '600',
                        minWidth: '120px'
                    }}
                >
                    <i className="fa fa-times" style={{ marginRight: '8px' }} />
                    Annuler
                </Button>
                <Button 
                    bsStyle={confirmStyle}
                    onClick={onConfirm}
                    style={{
                        borderRadius: '8px',
                        padding: '10px 25px',
                        fontWeight: '600',
                        minWidth: '120px',
                        boxShadow: confirmStyle === 'success'
                            ? '0 4px 15px rgba(76, 175, 80, 0.3)'
                            : confirmStyle === 'danger'
                            ? '0 4px 15px rgba(244, 67, 54, 0.3)'
                            : '0 4px 15px rgba(33, 150, 243, 0.3)'
                    }}
                >
                    <i className={iconClass} style={{ marginRight: '8px' }} />
                    {confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

DeleteConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    itemName: PropTypes.string.isRequired,
    title: PropTypes.string,
    confirmLabel: PropTypes.string,
    confirmStyle: PropTypes.oneOf(['danger', 'success', 'info', 'warning']),
    icon: PropTypes.string,
    message: PropTypes.string,
    isIrreversible: PropTypes.bool
};

export default DeleteConfirmationModal;
